import { createSlice } from "@reduxjs/toolkit";

export const ActiveTab = createSlice({
  name: "drawerTabs",
  initialState: {
    tabs: {
      user_cart: "ecommerce_cart",
      fess_structure: "tuition_fee_monthly",
    },
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.tabs = action.payload;
    },
  },
});

export const { setActiveTab } = ActiveTab.actions;

export default ActiveTab.reducer;
